import PropTypes from 'prop-types';
import React from 'react';

const Image = React.forwardRef(function Image({ alt = '', loading = 'lazy', src, ...props }, ref) {
  return <img {...props} ref={ref} alt={alt} loading={loading} src={src} />;
});

Image.propTypes = {
  alt: PropTypes.string,
  loading: PropTypes.oneOf(['lazy', 'eager']),
  src: PropTypes.string,
};

export default Image;
